/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect, useState } from "react";
import "../../../assets/styles/custom-style.css";
import { useAuth } from "../../../auth";
import { listReviewData } from "../core/_requests";
import { useLocation, useNavigate } from "react-router-dom";
import Pagination from "../../../component/Pagination";
import { ChefReview } from "../core/_models";
import { useFormattedUtils } from "../../../component/dateUtils";
import SearchInput from "../../../component/core/Searchinput";

const ListChefReview = () => {
  const navigate = useNavigate();
  const { formatDateUS } = useFormattedUtils();
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [listType, setListType] = useState<ChefReview[]>([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("recent"); // NEW: default filter

  const chefId = currentUser?.uuid;

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dataSearch = searchParams.get("search");

  useEffect(() => {
    if (dataSearch !== null) {
      setSearch(dataSearch);
    }
  }, [dataSearch]);

  const filterData = {
    search: dataSearch,
    chefId,
  };

  useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await listReviewData({
        search: dataSearch,
        chefId,
        filter,  // ✅ send filter
      });
      setListType(res?.data || []);
    } catch (error) {
      console.error("Error fetching Reviews:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [chefId, filter]); // ✅ re-fetch when filter changes
 // 🔥 refetch + sort when filter changes

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const clickApply = async () => {
    setLoading(true);
    const data = { search, chefId,filter };
    try {
      const res = await listReviewData(data);
      let reviews = res?.data || [];
      reviews = applyFilter(reviews, filter); // apply filter
      setListType(reviews);
    } catch (error) {
      console.error("Error fetching Reviews:", error);
    } finally {
      setLoading(false);
    }
  };

  const applyFilter = (reviews: ChefReview[], filterType: string) => {
    switch (filterType) {
      case "high":
        return [...reviews].sort((a, b) => (b.reviews || 0) - (a.reviews || 0));
      case "low":
        return [...reviews].sort((a, b) => (a.reviews || 0) - (b.reviews || 0));
      case "recent":
        return [...reviews].sort(
          (a, b) =>
            new Date(b.date).getTime() - new Date(a.date).getTime()
        );
      default:
        return reviews;
    }
  };

  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = listType.slice(indexOfFirstItem, indexOfLastItem);
  const pages = Math.ceil(listType.length / itemsPerPage);

  const pageNumbers = Array.from({ length: pages }, (_, i) => i + 1);

  const renderStars = (rating: number | null) => {
    return rating !== null
      ? Array.from({ length: 5 }, (_, i) => (
          <span
            key={i}
            className={`material-symbols-outlined ${
              i < Math.floor(rating)
                ? "text-warning"
                : i === Math.floor(rating) && rating % 1 !== 0
                ? "text-warning"
                : ""
            }`}
          >
            {i < Math.floor(rating)
              ? "star"
              : i === Math.floor(rating) && rating % 1 !== 0
              ? "star_half"
              : "star_outline"}
          </span>
        ))
      : null;
  };

  return (
    <>
      <section className="container-fluid">
        <div className="row">
          <section className="content-section">
            <section className="row main-content">
              <div className="title mb-3 d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Reviews ({listType.length})</h3>

        
              </div>

              <div className="col-12 title-btm">
                <SearchInput
                  value={search}
                  onChange={handleSearchChange}
                  onKeyUp={clickApply}
                />
                   <select
                  className="form-select w-auto"
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                >
                  <option value="recent">Most Recent</option>
                  <option value="high">Highest Rating</option>
                  <option value="low">Lowest Rating</option>
                </select>
              </div>
        {/* 🔥 Filter Dropdown */}
                <div className="col-12 title-btm">
             
                </div>
              <div className="table-wrap mt-4">
                <table className="table custom-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>User Name</th>
                      <th>Description</th>
                      <th>Review</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan={6} className="text-center">
                          Loading...
                        </td>
                      </tr>
                    ) : currentItems.length > 0 ? (
                      currentItems.map((item, i) => (
                        <tr key={item.primaryId}>
                          <td>{indexOfFirstItem + i + 1}</td>
                          <td>
                            <p className="mb-0">{item?.user?.name}</p>
                          </td>
                          <td>
                            <p className="mb-0">{item.description}</p>
                          </td>
                          <td>
                            <div>{renderStars(item.reviews)}</div>
                          </td>
                          <td>
                            <p className="mb-0 type">
                              {formatDateUS(item.date)}
                            </p>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="text-center">
                          No Reviews Submitted – Stay Tuned!
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <Pagination
                data={listType}
                indexOfFirstItem={indexOfFirstItem}
                indexOfLastItem={indexOfLastItem}
                currentItems={currentItems}
                pages={pages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pageNumbers={pageNumbers}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
              />
            </section>
          </section>
        </div>
      </section>
    </>
  );
};

export default ListChefReview;
